module.exports = {
  "interaction": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "screen": "string",
      "subscreen": "string",
      "action": "string"
    },
    "namespace": "enrichment-properties-lib",
    "version": "1"
  },
  "enriched-record": {
    "name": "Record was enriched",
    "class": "usage",
    "properties": {
      "objectType": [
        "company",
        "contact"
      ],
      "enrichmentType": [
        "bulk",
        "dataTest",
        "list",
        "single",
        "smartPropertySingle"
      ],
      "selectionType": [
        "manual",
        "all"
      ],
      "propertyCount": {
        "type": "number",
        "isOptional": true
      },
      "selectionCount": {
        "type": "number",
        "isOptional": true
      },
      "selectionDifference": {
        "type": "number",
        "isOptional": true
      },
      "includeAssociatedRecords": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "enrichment-properties-lib",
    "version": "1"
  },
  "changeSetting": {
    "name": "Enrichment Interaction",
    "class": "usage",
    "properties": {
      "setting": "string",
      "action": [
        "turn on",
        "turn off"
      ]
    },
    "namespace": "enrichment-properties-lib",
    "version": "1"
  }
};